import { displayToastError, http, msalAuth } from 'app';
import { IBootstrapResponse } from 'app/utils/types';
import config from 'config';

const getBootstrap = async (): Promise<IBootstrapResponse | undefined> => {
  try {
    const accounts = msalAuth.getAllAccounts();
    const result = await msalAuth.acquireTokenSilent({
      scopes: [config.AUTH.SCOPES || 'User.Read'],
      account: accounts[0]
    });

    const accessToken = result.accessToken;
    const url = `${config.INTEGRATION.bootstrap}?token=${accessToken}`;
    const response = await http.get(url);
    return response.data as IBootstrapResponse;
  } catch (error: any) {
    const errorMessage = error.response?.data?.message || error.message;

    displayToastError(String(errorMessage), 'Get bootstrap');

    throw new Error(errorMessage);
  }
};

export { getBootstrap };
